import registerRoutes from './routes';
import getDealersFactory from './services/list/getDealersList';
import getVMCAccountDisplayListFactory from './services/list/getVMCAccountDisplayList';
import vmcAccountDetailFactory from './services/detail/vmcAccountDetail';
import openAddAccountGroupFactory from '../accountGroups/services/add/openAddAccountGroupModal';
import openAddVmcAccountModalFactory from './services/addVmcAccount/openAddVmcAccountModal';
import addVmcAccountFactory from './services/addVmcAccount/addVmcAccount';
import deleteDealerFactory from './services/delete/deleteDealer';
import deleteVmcAccountFactory from './services/delete/deleteVmcAccount';
import editVmcAccountFactory from './services/editVmcAccount/editVmcAccount';
import dealerStatisticsFactory from './services/detail/dealerStatistics';
import getDealersByNumberFactory from './services/list/getDealersListByNumber';

export default function (app) {
    app.factory('getDealersList', getDealersFactory);
    app.factory('getVMCAccountDisplayList', getVMCAccountDisplayListFactory);
    app.factory('getDealersByNumber', getDealersByNumberFactory);
    app.factory('vmcAccountDetail', vmcAccountDetailFactory);

    app.factory('openAddAccountGroupModal', openAddAccountGroupFactory);

    app.factory('openAddVmcAccountModal', openAddVmcAccountModalFactory);
    app.factory('addVmcAccount', addVmcAccountFactory);

    app.factory('deleteDealer', deleteDealerFactory);

    app.factory('deleteVmcAccount', deleteVmcAccountFactory);
    app.factory('editVmcAccount', editVmcAccountFactory);

    app.factory('dealerStatistics', dealerStatisticsFactory);

    registerRoutes(app);
}



// WEBPACK FOOTER //
// ./Client/app/dealer/index.js